export default __webpack_public_path__ + "static/graph-two-9baed20bbb3ba58f1208f8982c06f0bc.png";